module.exports = __webpack_public_path__ + "static/media/itunes-rond..b1c37ad3.png";